<script>
	export let item;
	export let i;
	export let parent_id;
	export let type;

	function getYouTubeID(url) {
		var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
		var match = url.match(regExp);
		if (match && match[2].length == 11) {
			 var id = match[2];
			 var path = 'http://img.youtube.com/vi/'+id+'/0.jpg';
			 return id
		}
		return false
	}

	function handleClick(event) {
		var url = event.target.attributes['data-url']
		console.log(url)
	}

	let newitem = item
	if(item.subreddit) newitem.flag = item.subreddit

	newitem.media2 = {
		image: false,
		video: {
			id: false,
			url: false,
		}
	}

	if(item.media && item.media.oembed) {
		newitem.media2.image = item.media.oembed.thumbnail_url
		newitem.media2.video = {
			id: getYouTubeID( item.url ),
			url: item.url
		}

	}


	console.log(item)
</script>

{newitem.media2.image}
{#if type=="button"}
		<span class="btn btn-light xfs-4">

			{#if newitem.url}
			<a href="">
				{newitem.title}
			</a>
			&nbsp;&nbsp;
			{/if}
		<a href="">
			<i class="ri-mail-add-fill"></i>
		</a>

		</span>

	{:else}


  <li class="list-group-item d-flex Xjustify-content-between align-items-starXt {parent_id}-{i}">






    <div class="mx-2 Xme-auto p-2">


				<em class="fs-5 "> {newitem.title} </em>

				{#if newitem.description} <p class="text-muted">{newitem.description}</p>{/if}




				<div class="stage" on:click={handleClick} data-url=https://www.youtube.com/embed/{newitem.media2.video.id}>

					{#if newitem.media2.image}
					<div class="ratio ratio-16x9 sticky-top2  " style="width:auto;margin:1rem 12rem 0 0">
					  <img src="{newitem.media2.image}" />
					</div>
					{/if}

					<div class="ratio ratio-16x9 sticky-bottom">
						<iframe width="560" height="315" src="https://www.youtube.com/embed/{newitem.media2.video.id}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
					</div>

				</div>


				{#if newitem.url}

				<a class="btn btn-light btn-block" href="{newitem.url}">


					{#if newitem.flag}<span class="badge text-primary rounded-pill"> {newitem.flag}</span>{/if}

					{#if newitem.domain} <small class="text-muted">{newitem.domain}</small>{/if}


				</a>
				{/if}

				<span class="btn btn-light fs-4">

					{#if newitem.url}
					<a href="">
						<i class="ri-play-fill"></i>
					</a>
					&nbsp;&nbsp;
					{/if}
				<a href="">
					<i class="ri-mail-add-fill"></i>
				</a>
				&nbsp;&nbsp;
				<a href="">
					<i class="ri-whatsapp-fill "></i>
				</a>
				</span>



    </div>


  </li>


{/if}

<style>

	.btn {
		text-align: left;
	}
	a {
		text-decoration: none;
	}

	.btn-light { color: #0d6efd; }
	a.text-dark {
		text-decoration: none; border-bottom: 1px solid #0d6efd; padding-bottom: 6px; font-style: italic;
		display: block;
	}

	a:visited {
		color: inherit;
	}

	.list-group-item {
		border: none
	}

	</style>
